import "core-js/modules/es.array.map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
export default {
  name: "passwordLog",
  mixins: [loadMoreList, serchSelect],
  data: function data() {
    return {
      pagingReqFn: "updateLogData",
      pagingReqValue: "data",
      drawer: false,
      paramsData: {
        type: "1"
      },
      gameList: [],
      typeList: [{
        label: "通过密码修改",
        value: "1"
      }, {
        label: "通过邮箱修改",
        value: "2"
      }]
    };
  },
  activated: function activated() {
    var _this = this;

    this.$api.paymentGamesData().then(function (res) {
      if (res.code == 0) {
        _this.gameList = res.data;
      }
    });
  },
  created: function created() {
    this.getList();
  },
  methods: {
    exportdata: function exportdata() {
      var _this2 = this;

      var Dynamic = [{
        label: "游戏",
        prop: "show_name"
      }, {
        label: "账号",
        prop: "account"
      }, {
        label: "原密码",
        prop: "old_password"
      }, {
        label: "新密码",
        prop: "new_password"
      }, {
        label: "IP",
        prop: "ip"
      }, {
        label: "操作时间",
        prop: "created_at"
      }];
      this.$api.updateLogDataAll(this.paramsData).then(function (res) {
        if (res.code == 0) {
          res.data.map(function (i) {
            i.created_at = _this2.$times.timestampToTime(i.created_at);
          });

          _this2.$export.excel({
            columns: Dynamic,
            data: res.data,
            title: "密码修改日志"
          });
        }
      });
    }
  }
};